up.CannotMatch = class CannotMatch extends up.Error {
};
